import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function TopProdutosHoobuy2026() {
  return <ArticleLayout article={newArticles[2]} />;
}